import { CITY } from "../types";

export const cities0: CITY[] = [
  {
    id: 1,
    name: "ADANA",
    voterCountTotal: 1526827,
    votesCountTotal: 1313497,
    votesCountValid: 1289267,
    votesCountInvalid: 24230,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 432103 },
      { partyId: 2, partyName: "MHP", vote: 150093 },
      { partyId: 3, partyName: "HUDAPAR", vote: 6992 },
      { partyId: 4, partyName: "VATAN", vote: 2395 },
      { partyId: 5, partyName: "HDP", vote: 172831 },
      { partyId: 6, partyName: "CHP", vote: 337497 },
      { partyId: 7, partyName: "SP", vote: 13738 },
      { partyId: 8, partyName: "İYİP", vote: 159022 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 279 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 134 },
    ],
    // bagimsiz_toplam_oy: 413,
    union1Vote: 11404,
    union2Vote: 2779,
    parliamentarianCount: 15,
  },
  {
    id: 2,
    name: "ADIYAMAN",
    voterCountTotal: 399766,
    votesCountTotal: 345098,
    votesCountValid: 336384,
    votesCountInvalid: 8714,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 183772 },
      { partyId: 2, partyName: "MHP", vote: 30521 },
      { partyId: 3, partyName: "HUDAPAR", vote: 4249 },
      { partyId: 4, partyName: "VATAN", vote: 571 },
      { partyId: 5, partyName: "HDP", vote: 51641 },
      { partyId: 6, partyName: "CHP", vote: 39720 },
      { partyId: 7, partyName: "SP", vote: 5514 },
      { partyId: 8, partyName: "İYİP", vote: 17753 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2280,
    union2Vote: 363,
    parliamentarianCount: 5,
  },
  {
    id: 3,
    name: "AFYONKARAHİSAR",
    voterCountTotal: 507706,
    votesCountTotal: 459166,
    votesCountValid: 447355,
    votesCountInvalid: 11811,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 243613 },
      { partyId: 2, partyName: "MHP", vote: 62038 },
      { partyId: 3, partyName: "HUDAPAR", vote: 977 },
      { partyId: 4, partyName: "VATAN", vote: 1138 },
      { partyId: 5, partyName: "HDP", vote: 3382 },
      { partyId: 6, partyName: "CHP", vote: 63810 },
      { partyId: 7, partyName: "SP", vote: 4965 },
      { partyId: 8, partyName: "İYİP", vote: 60706 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 5846,
    union2Vote: 880,
    parliamentarianCount: 6,
  },
  {
    id: 4,
    name: "AĞRI",
    voterCountTotal: 296375,
    votesCountTotal: 232345,
    votesCountValid: 224267,
    votesCountInvalid: 8078,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 62284 },
      { partyId: 2, partyName: "MHP", vote: 5171 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1731 },
      { partyId: 4, partyName: "VATAN", vote: 402 },
      { partyId: 5, partyName: "HDP", vote: 142683 },
      { partyId: 6, partyName: "CHP", vote: 5421 },
      { partyId: 7, partyName: "SP", vote: 1813 },
      { partyId: 8, partyName: "İYİP", vote: 3501 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 139 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 148 },
    ],
    // bagimsiz_toplam_oy: 287,
    union1Vote: 821,
    union2Vote: 153,
    parliamentarianCount: 4,
  },
  {
    id: 68,
    name: "AKSARAY",
    voterCountTotal: 267068,
    votesCountTotal: 232175,
    votesCountValid: 226978,
    votesCountInvalid: 5197,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 125326 },
      { partyId: 2, partyName: "MHP", vote: 46588 },
      { partyId: 3, partyName: "HUDAPAR", vote: 639 },
      { partyId: 4, partyName: "VATAN", vote: 441 },
      { partyId: 5, partyName: "HDP", vote: 2461 },
      { partyId: 6, partyName: "CHP", vote: 21756 },
      { partyId: 7, partyName: "SP", vote: 1886 },
      { partyId: 8, partyName: "İYİP", vote: 24193 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 3337,
    union2Vote: 351,
    parliamentarianCount: 4,
  },
  {
    id: 5,
    name: "AMASYA",
    voterCountTotal: 246896,
    votesCountTotal: 225566,
    votesCountValid: 220743,
    votesCountInvalid: 4823,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 101546 },
      { partyId: 2, partyName: "MHP", vote: 27198 },
      { partyId: 3, partyName: "HUDAPAR", vote: 359 },
      { partyId: 4, partyName: "VATAN", vote: 447 },
      { partyId: 5, partyName: "HDP", vote: 3982 },
      { partyId: 6, partyName: "CHP", vote: 54803 },
      { partyId: 7, partyName: "SP", vote: 2469 },
      { partyId: 8, partyName: "İYİP", vote: 27122 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2350,
    union2Vote: 467,
    parliamentarianCount: 3,
  },
  {
    id: 6,
    name: "ANKARA-1",
    voterCountTotal: 1401859,
    votesCountTotal: 1250107,
    votesCountValid: 1231433,
    votesCountInvalid: 18674,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 364122 },
      { partyId: 2, partyName: "MHP", vote: 130264 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1146 },
      { partyId: 4, partyName: "VATAN", vote: 3178 },
      { partyId: 5, partyName: "HDP", vote: 105479 },
      { partyId: 6, partyName: "CHP", vote: 440621 },
      { partyId: 7, partyName: "SP", vote: 16959 },
      { partyId: 8, partyName: "İYİP", vote: 153949 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 254 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 75 },
      { partyId: -3, partyName: "Bağımsız 3", vote: 695 },
    ],
    // bagimsiz_toplam_oy: 1024,
    union1Vote: 10342,
    union2Vote: 4349,
    parliamentarianCount: 13,
  },
  {
    id: 6,
    name: "ANKARA-2",
    voterCountTotal: 1185237,
    votesCountTotal: 1056573,
    votesCountValid: 1040194,
    votesCountInvalid: 16379,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 520733 },
      { partyId: 2, partyName: "MHP", vote: 154449 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1226 },
      { partyId: 4, partyName: "VATAN", vote: 1952 },
      { partyId: 5, partyName: "HDP", vote: 39635 },
      { partyId: 6, partyName: "CHP", vote: 180734 },
      { partyId: 7, partyName: "SP", vote: 16096 },
      { partyId: 8, partyName: "İYİP", vote: 109646 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 13379,
    union2Vote: 2344,
    parliamentarianCount: 11,
  },
  {
    id: 6,
    name: "ANKARA-3",
    voterCountTotal: 1322490,
    votesCountTotal: 1185636,
    votesCountValid: 1168663,
    votesCountInvalid: 16973,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 466935 },
      { partyId: 2, partyName: "MHP", vote: 162684 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1325 },
      { partyId: 4, partyName: "VATAN", vote: 2234 },
      { partyId: 5, partyName: "HDP", vote: 63678 },
      { partyId: 6, partyName: "CHP", vote: 278375 },
      { partyId: 7, partyName: "SP", vote: 18679 },
      { partyId: 8, partyName: "İYİP", vote: 158152 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 166 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 303 },
    ],
    // bagimsiz_toplam_oy: 469,
    union1Vote: 12546,
    union2Vote: 3586,
    parliamentarianCount: 12,
  },
  {
    id: 7,
    name: "ANTALYA",
    voterCountTotal: 1683522,
    votesCountTotal: 1468770,
    votesCountValid: 1435890,
    votesCountInvalid: 32880,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 485103 },
      { partyId: 2, partyName: "MHP", vote: 143406 },
      { partyId: 3, partyName: "HUDAPAR", vote: 3131 },
      { partyId: 4, partyName: "VATAN", vote: 3798 },
      { partyId: 5, partyName: "HDP", vote: 100782 },
      { partyId: 6, partyName: "CHP", vote: 420963 },
      { partyId: 7, partyName: "SP", vote: 13781 },
      { partyId: 8, partyName: "İYİP", vote: 246905 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 424 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 41 },
      { partyId: -3, partyName: "Bağımsız 3", vote: 566 },
      { partyId: -4, partyName: "Bağımsız 4", vote: 147 },
      { partyId: -5, partyName: "Bağımsız 5", vote: 107 },
    ],
    // bagimsiz_toplam_oy: 1285,
    union1Vote: 12237,
    union2Vote: 4499,
    parliamentarianCount: 17,
  },
  {
    id: 75,
    name: "ARDAHAN",
    voterCountTotal: 69575,
    votesCountTotal: 58863,
    votesCountValid: 56674,
    votesCountInvalid: 2189,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 20431 },
      { partyId: 2, partyName: "MHP", vote: 3746 },
      { partyId: 3, partyName: "HUDAPAR", vote: 203 },
      { partyId: 4, partyName: "VATAN", vote: 202 },
      { partyId: 5, partyName: "HDP", vote: 13358 },
      { partyId: 6, partyName: "CHP", vote: 14688 },
      { partyId: 7, partyName: "SP", vote: 569 },
      { partyId: 8, partyName: "İYİP", vote: 2900 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 435,
    union2Vote: 142,
    parliamentarianCount: 2,
  },
  {
    id: 8,
    name: "ARTVİN",
    voterCountTotal: 131386,
    votesCountTotal: 115066,
    votesCountValid: 111991,
    votesCountInvalid: 3075,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 44100 },
      { partyId: 2, partyName: "MHP", vote: 11269 },
      { partyId: 3, partyName: "HUDAPAR", vote: 325 },
      { partyId: 4, partyName: "VATAN", vote: 423 },
      { partyId: 5, partyName: "HDP", vote: 5076 },
      { partyId: 6, partyName: "CHP", vote: 36105 },
      { partyId: 7, partyName: "SP", vote: 1641 },
      { partyId: 8, partyName: "İYİP", vote: 11600 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1102,
    union2Vote: 350,
    parliamentarianCount: 2,
  },
  {
    id: 9,
    name: "AYDIN",
    voterCountTotal: 816894,
    votesCountTotal: 726243,
    votesCountValid: 709539,
    votesCountInvalid: 16704,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 222373 },
      { partyId: 2, partyName: "MHP", vote: 56416 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1795 },
      { partyId: 4, partyName: "VATAN", vote: 2594 },
      { partyId: 5, partyName: "HDP", vote: 64644 },
      { partyId: 6, partyName: "CHP", vote: 242894 },
      { partyId: 7, partyName: "SP", vote: 4939 },
      { partyId: 8, partyName: "İYİP", vote: 106555 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 5032,
    union2Vote: 2297,
    parliamentarianCount: 8,
  },
  {
    id: 10,
    name: "BALIKESİR",
    voterCountTotal: 947177,
    votesCountTotal: 858214,
    votesCountValid: 838607,
    votesCountInvalid: 19607,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 338879 },
      { partyId: 2, partyName: "MHP", vote: 62255 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1500 },
      { partyId: 4, partyName: "VATAN", vote: 2812 },
      { partyId: 5, partyName: "HDP", vote: 32275 },
      { partyId: 6, partyName: "CHP", vote: 256303 },
      { partyId: 7, partyName: "SP", vote: 9811 },
      { partyId: 8, partyName: "İYİP", vote: 125333 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 225 },
    ],
    // bagimsiz_toplam_oy: 225,
    union1Vote: 6665,
    union2Vote: 2549,
    parliamentarianCount: 9,
  },
  {
    id: 74,
    name: "BARTIN",
    voterCountTotal: 146984,
    votesCountTotal: 128658,
    votesCountValid: 123095,
    votesCountInvalid: 5563,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 56620 },
      { partyId: 2, partyName: "MHP", vote: 20894 },
      { partyId: 3, partyName: "HUDAPAR", vote: 345 },
      { partyId: 4, partyName: "VATAN", vote: 662 },
      { partyId: 5, partyName: "HDP", vote: 1502 },
      { partyId: 6, partyName: "CHP", vote: 31404 },
      { partyId: 7, partyName: "SP", vote: 2639 },
      { partyId: 8, partyName: "İYİP", vote: 7199 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1500,
    union2Vote: 330,
    parliamentarianCount: 2,
  },
  {
    id: 72,
    name: "BATMAN",
    voterCountTotal: 342380,
    votesCountTotal: 293091,
    votesCountValid: 284060,
    votesCountInvalid: 9031,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 67789 },
      { partyId: 2, partyName: "MHP", vote: 2833 },
      { partyId: 3, partyName: "HUDAPAR", vote: 0 },
      { partyId: 4, partyName: "VATAN", vote: 420 },
      { partyId: 5, partyName: "HDP", vote: 180318 },
      { partyId: 6, partyName: "CHP", vote: 3740 },
      { partyId: 7, partyName: "SP", vote: 8971 },
      { partyId: 8, partyName: "İYİP", vote: 3127 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 15998 },
    ],
    // bagimsiz_toplam_oy: 15998,
    union1Vote: 633,
    union2Vote: 231,
    parliamentarianCount: 5,
  },
  {
    id: 69,
    name: "BAYBURT",
    voterCountTotal: 56249,
    votesCountTotal: 48364,
    votesCountValid: 47637,
    votesCountInvalid: 727,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 27008 },
      { partyId: 2, partyName: "MHP", vote: 13128 },
      { partyId: 3, partyName: "HUDAPAR", vote: 77 },
      { partyId: 4, partyName: "VATAN", vote: 47 },
      { partyId: 5, partyName: "HDP", vote: 338 },
      { partyId: 6, partyName: "CHP", vote: 1823 },
      { partyId: 7, partyName: "SP", vote: 1571 },
      { partyId: 8, partyName: "İYİP", vote: 2941 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 662,
    union2Vote: 42,
    parliamentarianCount: 1,
  },
  {
    id: 11,
    name: "BİLECİK",
    voterCountTotal: 154403,
    votesCountTotal: 140203,
    votesCountValid: 137214,
    votesCountInvalid: 2989,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 58110 },
      { partyId: 2, partyName: "MHP", vote: 12666 },
      { partyId: 3, partyName: "HUDAPAR", vote: 454 },
      { partyId: 4, partyName: "VATAN", vote: 375 },
      { partyId: 5, partyName: "HDP", vote: 4040 },
      { partyId: 6, partyName: "CHP", vote: 38807 },
      { partyId: 7, partyName: "SP", vote: 1539 },
      { partyId: 8, partyName: "İYİP", vote: 19656 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1160,
    union2Vote: 407,
    parliamentarianCount: 2,
  },
  {
    id: 12,
    name: "BİNGÖL",
    voterCountTotal: 181265,
    votesCountTotal: 147204,
    votesCountValid: 140415,
    votesCountInvalid: 6789,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 77051 },
      { partyId: 2, partyName: "MHP", vote: 8075 },
      { partyId: 3, partyName: "HUDAPAR", vote: 6296 },
      { partyId: 4, partyName: "VATAN", vote: 332 },
      { partyId: 5, partyName: "HDP", vote: 38050 },
      { partyId: 6, partyName: "CHP", vote: 2503 },
      { partyId: 7, partyName: "SP", vote: 1517 },
      { partyId: 8, partyName: "İYİP", vote: 5661 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 801,
    union2Vote: 129,
    parliamentarianCount: 3,
  },
  {
    id: 13,
    name: "BİTLİS",
    voterCountTotal: 198961,
    votesCountTotal: 165568,
    votesCountValid: 159518,
    votesCountInvalid: 6050,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 70488 },
      { partyId: 2, partyName: "MHP", vote: 6242 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1809 },
      { partyId: 4, partyName: "VATAN", vote: 526 },
      { partyId: 5, partyName: "HDP", vote: 69110 },
      { partyId: 6, partyName: "CHP", vote: 3583 },
      { partyId: 7, partyName: "SP", vote: 1767 },
      { partyId: 8, partyName: "İYİP", vote: 5142 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 741,
    union2Vote: 110,
    parliamentarianCount: 3,
  },
  {
    id: 14,
    name: "BOLU",
    voterCountTotal: 223121,
    votesCountTotal: 199734,
    votesCountValid: 195575,
    votesCountInvalid: 4159,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 100154 },
      { partyId: 2, partyName: "MHP", vote: 29100 },
      { partyId: 3, partyName: "HUDAPAR", vote: 374 },
      { partyId: 4, partyName: "VATAN", vote: 562 },
      { partyId: 5, partyName: "HDP", vote: 3140 },
      { partyId: 6, partyName: "CHP", vote: 39527 },
      { partyId: 7, partyName: "SP", vote: 2998 },
      { partyId: 8, partyName: "İYİP", vote: 16842 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2353,
    union2Vote: 525,
    parliamentarianCount: 3,
  },
  {
    id: 15,
    name: "BURDUR",
    voterCountTotal: 196733,
    votesCountTotal: 177117,
    votesCountValid: 171133,
    votesCountInvalid: 5984,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 72191 },
      { partyId: 2, partyName: "MHP", vote: 21284 },
      { partyId: 3, partyName: "HUDAPAR", vote: 564 },
      { partyId: 4, partyName: "VATAN", vote: 736 },
      { partyId: 5, partyName: "HDP", vote: 2468 },
      { partyId: 6, partyName: "CHP", vote: 34533 },
      { partyId: 7, partyName: "SP", vote: 2643 },
      { partyId: 8, partyName: "İYİP", vote: 34726 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1542,
    union2Vote: 446,
    parliamentarianCount: 3,
  },
  {
    id: 16,
    name: "BURSA-1",
    voterCountTotal: 1102185,
    votesCountTotal: 991424,
    votesCountValid: 972351,
    votesCountInvalid: 19073,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 410195 },
      { partyId: 2, partyName: "MHP", vote: 95343 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1684 },
      { partyId: 4, partyName: "VATAN", vote: 2313 },
      { partyId: 5, partyName: "HDP", vote: 42473 },
      { partyId: 6, partyName: "CHP", vote: 250893 },
      { partyId: 7, partyName: "SP", vote: 16150 },
      { partyId: 8, partyName: "İYİP", vote: 140212 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 250 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 635 },
    ],
    // bagimsiz_toplam_oy: 885,
    union1Vote: 9074,
    union2Vote: 3129,
    parliamentarianCount: 10,
  },
  {
    id: 16,
    name: "BURSA-2",
    voterCountTotal: 1047152,
    votesCountTotal: 938619,
    votesCountValid: 921044,
    votesCountInvalid: 17575,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 445559 },
      { partyId: 2, partyName: "MHP", vote: 105768 },
      { partyId: 3, partyName: "HUDAPAR", vote: 2742 },
      { partyId: 4, partyName: "VATAN", vote: 2248 },
      { partyId: 5, partyName: "HDP", vote: 58408 },
      { partyId: 6, partyName: "CHP", vote: 178822 },
      { partyId: 7, partyName: "SP", vote: 16646 },
      { partyId: 8, partyName: "İYİP", vote: 98604 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 10029,
    union2Vote: 2218,
    parliamentarianCount: 10,
  },
  {
    id: 17,
    name: "ÇANAKKALE",
    voterCountTotal: 407273,
    votesCountTotal: 371045,
    votesCountValid: 362838,
    votesCountInvalid: 8207,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 131900 },
      { partyId: 2, partyName: "MHP", vote: 24648 },
      { partyId: 3, partyName: "HUDAPAR", vote: 699 },
      { partyId: 4, partyName: "VATAN", vote: 1215 },
      { partyId: 5, partyName: "HDP", vote: 12069 },
      { partyId: 6, partyName: "CHP", vote: 123725 },
      { partyId: 7, partyName: "SP", vote: 2786 },
      { partyId: 8, partyName: "İYİP", vote: 61873 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 76 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 187 },
    ],
    // bagimsiz_toplam_oy: 263,
    union1Vote: 2476,
    union2Vote: 1184,
    parliamentarianCount: 4,
  },
  {
    id: 18,
    name: "ÇANKIRI",
    voterCountTotal: 134311,
    votesCountTotal: 118106,
    votesCountValid: 115544,
    votesCountInvalid: 2562,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 67305 },
      { partyId: 2, partyName: "MHP", vote: 22626 },
      { partyId: 3, partyName: "HUDAPAR", vote: 203 },
      { partyId: 4, partyName: "VATAN", vote: 241 },
      { partyId: 5, partyName: "HDP", vote: 702 },
      { partyId: 6, partyName: "CHP", vote: 7277 },
      { partyId: 7, partyName: "SP", vote: 1270 },
      { partyId: 8, partyName: "İYİP", vote: 13856 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1839,
    union2Vote: 225,
    parliamentarianCount: 2,
  },
  {
    id: 19,
    name: "ÇORUM",
    voterCountTotal: 391400,
    votesCountTotal: 356078,
    votesCountValid: 348188,
    votesCountInvalid: 7890,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 178083 },
      { partyId: 2, partyName: "MHP", vote: 48622 },
      { partyId: 3, partyName: "HUDAPAR", vote: 620 },
      { partyId: 4, partyName: "VATAN", vote: 840 },
      { partyId: 5, partyName: "HDP", vote: 11230 },
      { partyId: 6, partyName: "CHP", vote: 70591 },
      { partyId: 7, partyName: "SP", vote: 3801 },
      { partyId: 8, partyName: "İYİP", vote: 29586 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 4157,
    union2Vote: 658,
    parliamentarianCount: 4,
  },
  {
    id: 20,
    name: "DENİZLİ",
    voterCountTotal: 749055,
    votesCountTotal: 682660,
    votesCountValid: 663996,
    votesCountInvalid: 18664,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 263997 },
      { partyId: 2, partyName: "MHP", vote: 60468 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1714 },
      { partyId: 4, partyName: "VATAN", vote: 2121 },
      { partyId: 5, partyName: "HDP", vote: 24029 },
      { partyId: 6, partyName: "CHP", vote: 187080 },
      { partyId: 7, partyName: "SP", vote: 5532 },
      { partyId: 8, partyName: "İYİP", vote: 111117 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 573 },
    ],
    // bagimsiz_toplam_oy: 573,
    union1Vote: 5282,
    union2Vote: 2083,
    parliamentarianCount: 7,
  },
  {
    id: 21,
    name: "DİYARBAKIR",
    voterCountTotal: 1024929,
    votesCountTotal: 856317,
    votesCountValid: 826242,
    votesCountInvalid: 30075,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 167805 },
      { partyId: 2, partyName: "MHP", vote: 9828 },
      { partyId: 3, partyName: "HUDAPAR", vote: 0 },
      { partyId: 4, partyName: "VATAN", vote: 1155 },
      { partyId: 5, partyName: "HDP", vote: 554172 },
      { partyId: 6, partyName: "CHP", vote: 16562 },
      { partyId: 7, partyName: "SP", vote: 13955 },
      { partyId: 8, partyName: "İYİP", vote: 22575 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 175 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 186 },
      { partyId: -3, partyName: "Bağımsız 3", vote: 273 },
      { partyId: -4, partyName: "Bağımsız 4", vote: 1098 },
      { partyId: -5, partyName: "Bağımsız 5", vote: 136 },
      { partyId: -6, partyName: "Bağımsız 6", vote: 648 },
      { partyId: -7, partyName: "Bağımsız 7", vote: 35239 },
    ],
    // bagimsiz_toplam_oy: 37755,
    union1Vote: 1828,
    union2Vote: 607,
    parliamentarianCount: 12,
  },
  {
    id: 81,
    name: "DÜZCE",
    voterCountTotal: 268337,
    votesCountTotal: 244322,
    votesCountValid: 239644,
    votesCountInvalid: 4678,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 132021 },
      { partyId: 2, partyName: "MHP", vote: 44739 },
      { partyId: 3, partyName: "HUDAPAR", vote: 303 },
      { partyId: 4, partyName: "VATAN", vote: 624 },
      { partyId: 5, partyName: "HDP", vote: 3818 },
      { partyId: 6, partyName: "CHP", vote: 34297 },
      { partyId: 7, partyName: "SP", vote: 3584 },
      { partyId: 8, partyName: "İYİP", vote: 16221 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 3541,
    union2Vote: 496,
    parliamentarianCount: 3,
  },
  {
    id: 22,
    name: "EDİRNE",
    voterCountTotal: 311104,
    votesCountTotal: 275162,
    votesCountValid: 268077,
    votesCountInvalid: 7085,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 73630 },
      { partyId: 2, partyName: "MHP", vote: 13104 },
      { partyId: 3, partyName: "HUDAPAR", vote: 607 },
      { partyId: 4, partyName: "VATAN", vote: 863 },
      { partyId: 5, partyName: "HDP", vote: 8744 },
      { partyId: 6, partyName: "CHP", vote: 123252 },
      { partyId: 7, partyName: "SP", vote: 2765 },
      { partyId: 8, partyName: "İYİP", vote: 42614 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 218 },
    ],
    // bagimsiz_toplam_oy: 218,
    union1Vote: 1247,
    union2Vote: 1033,
    parliamentarianCount: 4,
  },
  {
    id: 23,
    name: "ELAZIĞ",
    voterCountTotal: 412412,
    votesCountTotal: 349331,
    votesCountValid: 340826,
    votesCountInvalid: 8505,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 183604 },
      { partyId: 2, partyName: "MHP", vote: 46028 },
      { partyId: 3, partyName: "HUDAPAR", vote: 5197 },
      { partyId: 4, partyName: "VATAN", vote: 559 },
      { partyId: 5, partyName: "HDP", vote: 33633 },
      { partyId: 6, partyName: "CHP", vote: 35651 },
      { partyId: 7, partyName: "SP", vote: 6078 },
      { partyId: 8, partyName: "İYİP", vote: 26396 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 3248,
    union2Vote: 432,
    parliamentarianCount: 5,
  },
  {
    id: 24,
    name: "ERZİNCAN",
    voterCountTotal: 162532,
    votesCountTotal: 146355,
    votesCountValid: 144035,
    votesCountInvalid: 2320,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 63013 },
      { partyId: 2, partyName: "MHP", vote: 26786 },
      { partyId: 3, partyName: "HUDAPAR", vote: 138 },
      { partyId: 4, partyName: "VATAN", vote: 148 },
      { partyId: 5, partyName: "HDP", vote: 7615 },
      { partyId: 6, partyName: "CHP", vote: 36902 },
      { partyId: 7, partyName: "SP", vote: 1589 },
      { partyId: 8, partyName: "İYİP", vote: 5983 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1654,
    union2Vote: 207,
    parliamentarianCount: 2,
  },
  {
    id: 25,
    name: "ERZURUM",
    voterCountTotal: 494291,
    votesCountTotal: 431114,
    votesCountValid: 422817,
    votesCountInvalid: 8297,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 227575 },
      { partyId: 2, partyName: "MHP", vote: 78125 },
      { partyId: 3, partyName: "HUDAPAR", vote: 833 },
      { partyId: 4, partyName: "VATAN", vote: 680 },
      { partyId: 5, partyName: "HDP", vote: 49885 },
      { partyId: 6, partyName: "CHP", vote: 16790 },
      { partyId: 7, partyName: "SP", vote: 7515 },
      { partyId: 8, partyName: "İYİP", vote: 34644 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 6199,
    union2Vote: 571,
    parliamentarianCount: 6,
  },
  {
    id: 26,
    name: "ESKİŞEHİR",
    voterCountTotal: 646221,
    votesCountTotal: 575177,
    votesCountValid: 564067,
    votesCountInvalid: 11110,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 212446 },
      { partyId: 2, partyName: "MHP", vote: 55273 },
      { partyId: 3, partyName: "HUDAPAR", vote: 758 },
      { partyId: 4, partyName: "VATAN", vote: 1398 },
      { partyId: 5, partyName: "HDP", vote: 21797 },
      { partyId: 6, partyName: "CHP", vote: 183089 },
      { partyId: 7, partyName: "SP", vote: 6270 },
      { partyId: 8, partyName: "İYİP", vote: 75465 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 277 },
    ],
    // bagimsiz_toplam_oy: 277,
    union1Vote: 5145,
    union2Vote: 2149,
    parliamentarianCount: 6,
  },
  {
    id: 27,
    name: "GAZİANTEP",
    voterCountTotal: 1216402,
    votesCountTotal: 1039392,
    votesCountValid: 1019525,
    votesCountInvalid: 19867,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 515715 },
      { partyId: 2, partyName: "MHP", vote: 128473 },
      { partyId: 3, partyName: "HUDAPAR", vote: 8703 },
      { partyId: 4, partyName: "VATAN", vote: 1947 },
      { partyId: 5, partyName: "HDP", vote: 119393 },
      { partyId: 6, partyName: "CHP", vote: 152162 },
      { partyId: 7, partyName: "SP", vote: 12257 },
      { partyId: 8, partyName: "İYİP", vote: 68450 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 10891,
    union2Vote: 1534,
    parliamentarianCount: 14,
  },
  {
    id: 28,
    name: "GİRESUN",
    voterCountTotal: 334730,
    votesCountTotal: 290219,
    votesCountValid: 282863,
    votesCountInvalid: 7356,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 149135 },
      { partyId: 2, partyName: "MHP", vote: 30280 },
      { partyId: 3, partyName: "HUDAPAR", vote: 802 },
      { partyId: 4, partyName: "VATAN", vote: 812 },
      { partyId: 5, partyName: "HDP", vote: 2983 },
      { partyId: 6, partyName: "CHP", vote: 49930 },
      { partyId: 7, partyName: "SP", vote: 3542 },
      { partyId: 8, partyName: "İYİP", vote: 41343 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 3356,
    union2Vote: 680,
    parliamentarianCount: 4,
  },
  {
    id: 29,
    name: "GÜMÜŞHANE",
    voterCountTotal: 100853,
    votesCountTotal: 80733,
    votesCountValid: 78858,
    votesCountInvalid: 1875,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 44124 },
      { partyId: 2, partyName: "MHP", vote: 16199 },
      { partyId: 3, partyName: "HUDAPAR", vote: 220 },
      { partyId: 4, partyName: "VATAN", vote: 178 },
      { partyId: 5, partyName: "HDP", vote: 654 },
      { partyId: 6, partyName: "CHP", vote: 5580 },
      { partyId: 7, partyName: "SP", vote: 1575 },
      { partyId: 8, partyName: "İYİP", vote: 9048 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1154,
    union2Vote: 126,
    parliamentarianCount: 2,
  },
  {
    id: 30,
    name: "HAKKARİ",
    voterCountTotal: 168438,
    votesCountTotal: 140276,
    votesCountValid: 135566,
    votesCountInvalid: 4710,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 25544 },
      { partyId: 2, partyName: "MHP", vote: 4762 },
      { partyId: 3, partyName: "HUDAPAR", vote: 792 },
      { partyId: 4, partyName: "VATAN", vote: 271 },
      { partyId: 5, partyName: "HDP", vote: 97337 },
      { partyId: 6, partyName: "CHP", vote: 4033 },
      { partyId: 7, partyName: "SP", vote: 705 },
      { partyId: 8, partyName: "İYİP", vote: 1633 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 402,
    union2Vote: 87,
    parliamentarianCount: 3,
  },
  {
    id: 31,
    name: "HATAY",
    voterCountTotal: 1042335,
    votesCountTotal: 925282,
    votesCountValid: 911280,
    votesCountInvalid: 14002,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 320185 },
      { partyId: 2, partyName: "MHP", vote: 131179 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1511 },
      { partyId: 4, partyName: "VATAN", vote: 1290 },
      { partyId: 5, partyName: "HDP", vote: 98645 },
      { partyId: 6, partyName: "CHP", vote: 281145 },
      { partyId: 7, partyName: "SP", vote: 8189 },
      { partyId: 8, partyName: "İYİP", vote: 59911 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 7568,
    union2Vote: 1657,
    parliamentarianCount: 11,
  },
  {
    id: 76,
    name: "IĞDIR",
    voterCountTotal: 119735,
    votesCountTotal: 93297,
    votesCountValid: 91115,
    votesCountInvalid: 2182,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 17737 },
      { partyId: 2, partyName: "MHP", vote: 21885 },
      { partyId: 3, partyName: "HUDAPAR", vote: 198 },
      { partyId: 4, partyName: "VATAN", vote: 203 },
      { partyId: 5, partyName: "HDP", vote: 41057 },
      { partyId: 6, partyName: "CHP", vote: 2141 },
      { partyId: 7, partyName: "SP", vote: 1836 },
      { partyId: 8, partyName: "İYİP", vote: 5336 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 607,
    union2Vote: 115,
    parliamentarianCount: 2,
  },
  {
    id: 32,
    name: "ISPARTA",
    voterCountTotal: 312990,
    votesCountTotal: 278869,
    votesCountValid: 271606,
    votesCountInvalid: 7263,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 127095 },
      { partyId: 2, partyName: "MHP", vote: 35449 },
      { partyId: 3, partyName: "HUDAPAR", vote: 710 },
      { partyId: 4, partyName: "VATAN", vote: 897 },
      { partyId: 5, partyName: "HDP", vote: 4503 },
      { partyId: 6, partyName: "CHP", vote: 44404 },
      { partyId: 7, partyName: "SP", vote: 4118 },
      { partyId: 8, partyName: "İYİP", vote: 50786 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2906,
    union2Vote: 738,
    parliamentarianCount: 4,
  },
  {
    id: 34,
    name: "İSTANBUL-1",
    voterCountTotal: 3822256,
    votesCountTotal: 3403734,
    votesCountValid: 3350363,
    votesCountInvalid: 53371,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 1356935 },
      { partyId: 2, partyName: "MHP", vote: 270335 },
      { partyId: 3, partyName: "HUDAPAR", vote: 4766 },
      { partyId: 4, partyName: "VATAN", vote: 7322 },
      { partyId: 5, partyName: "HDP", vote: 372793 },
      { partyId: 6, partyName: "CHP", vote: 972092 },
      { partyId: 7, partyName: "SP", vote: 52353 },
      { partyId: 8, partyName: "İYİP", vote: 275679 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 1714 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 189 },
    ],
    // bagimsiz_toplam_oy: 1903,
    union1Vote: 26274,
    union2Vote: 9911,
    parliamentarianCount: 35,
  },
  {
    id: 34,
    name: "İSTANBUL-2",
    voterCountTotal: 3044957,
    votesCountTotal: 2657989,
    votesCountValid: 2614767,
    votesCountInvalid: 43222,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 1158833 },
      { partyId: 2, partyName: "MHP", vote: 208937 },
      { partyId: 3, partyName: "HUDAPAR", vote: 5320 },
      { partyId: 4, partyName: "VATAN", vote: 5026 },
      { partyId: 5, partyName: "HDP", vote: 317391 },
      { partyId: 6, partyName: "CHP", vote: 648737 },
      { partyId: 7, partyName: "SP", vote: 40999 },
      { partyId: 8, partyName: "İYİP", vote: 199693 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 810 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 105 },
      { partyId: -3, partyName: "Bağımsız 3", vote: 138 },
      { partyId: -4, partyName: "Bağımsız 4", vote: 117 },
    ],
    // bagimsiz_toplam_oy: 1170,
    union1Vote: 21480,
    union2Vote: 7181,
    parliamentarianCount: 28,
  },
  {
    id: 34,
    name: "İSTANBUL-3",
    voterCountTotal: 3706330,
    votesCountTotal: 3242484,
    votesCountValid: 3189988,
    votesCountInvalid: 52496,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 1306005 },
      { partyId: 2, partyName: "MHP", vote: 265996 },
      { partyId: 3, partyName: "HUDAPAR", vote: 6514 },
      { partyId: 4, partyName: "VATAN", vote: 5738 },
      { partyId: 5, partyName: "HDP", vote: 456265 },
      { partyId: 6, partyName: "CHP", vote: 808690 },
      { partyId: 7, partyName: "SP", vote: 43300 },
      { partyId: 8, partyName: "İYİP", vote: 262799 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 657 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 137 },
      { partyId: -3, partyName: "Bağımsız 3", vote: 108 },
      { partyId: -4, partyName: "Bağımsız 4", vote: 105 },
    ],
    // bagimsiz_toplam_oy: 1007,
    union1Vote: 25218,
    union2Vote: 8456,
    parliamentarianCount: 35,
  },
  {
    id: 35,
    name: "İZMİR-1",
    voterCountTotal: 1579092,
    votesCountTotal: 1397565,
    votesCountValid: 1373392,
    votesCountInvalid: 24173,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 377584 },
      { partyId: 2, partyName: "MHP", vote: 78038 },
      { partyId: 3, partyName: "HUDAPAR", vote: 2276 },
      { partyId: 4, partyName: "VATAN", vote: 4223 },
      { partyId: 5, partyName: "HDP", vote: 169996 },
      { partyId: 6, partyName: "CHP", vote: 569968 },
      { partyId: 7, partyName: "SP", vote: 10758 },
      { partyId: 8, partyName: "İYİP", vote: 145611 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 272 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 687 },
    ],
    // bagimsiz_toplam_oy: 959,
    union1Vote: 9097,
    union2Vote: 4882,
    parliamentarianCount: 14,
  },
  {
    id: 35,
    name: "İZMİR-2",
    voterCountTotal: 1653277,
    votesCountTotal: 1483365,
    votesCountValid: 1454605,
    votesCountInvalid: 28760,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 398659 },
      { partyId: 2, partyName: "MHP", vote: 94889 },
      { partyId: 3, partyName: "HUDAPAR", vote: 2449 },
      { partyId: 4, partyName: "VATAN", vote: 4725 },
      { partyId: 5, partyName: "HDP", vote: 149819 },
      { partyId: 6, partyName: "CHP", vote: 610799 },
      { partyId: 7, partyName: "SP", vote: 11689 },
      { partyId: 8, partyName: "İYİP", vote: 165801 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 993 },
    ],
    // bagimsiz_toplam_oy: 993,
    union1Vote: 9315,
    union2Vote: 5467,
    parliamentarianCount: 14,
  },
  {
    id: 46,
    name: "KAHRAMANMARAŞ",
    voterCountTotal: 739457,
    votesCountTotal: 661140,
    votesCountValid: 648790,
    votesCountInvalid: 12350,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 375008 },
      { partyId: 2, partyName: "MHP", vote: 105917 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1531 },
      { partyId: 4, partyName: "VATAN", vote: 1323 },
      { partyId: 5, partyName: "HDP", vote: 22252 },
      { partyId: 6, partyName: "CHP", vote: 61433 },
      { partyId: 7, partyName: "SP", vote: 9848 },
      { partyId: 8, partyName: "İYİP", vote: 63283 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 7388,
    union2Vote: 807,
    parliamentarianCount: 8,
  },
  {
    id: 78,
    name: "KARABÜK",
    voterCountTotal: 176018,
    votesCountTotal: 154405,
    votesCountValid: 150057,
    votesCountInvalid: 4348,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 79446 },
      { partyId: 2, partyName: "MHP", vote: 20274 },
      { partyId: 3, partyName: "HUDAPAR", vote: 323 },
      { partyId: 4, partyName: "VATAN", vote: 552 },
      { partyId: 5, partyName: "HDP", vote: 1486 },
      { partyId: 6, partyName: "CHP", vote: 24744 },
      { partyId: 7, partyName: "SP", vote: 2605 },
      { partyId: 8, partyName: "İYİP", vote: 18490 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1763,
    union2Vote: 374,
    parliamentarianCount: 3,
  },
  {
    id: 70,
    name: "KARAMAN",
    voterCountTotal: 173867,
    votesCountTotal: 156830,
    votesCountValid: 152972,
    votesCountInvalid: 3858,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 80498 },
      { partyId: 2, partyName: "MHP", vote: 22826 },
      { partyId: 3, partyName: "HUDAPAR", vote: 356 },
      { partyId: 4, partyName: "VATAN", vote: 521 },
      { partyId: 5, partyName: "HDP", vote: 1671 },
      { partyId: 6, partyName: "CHP", vote: 24608 },
      { partyId: 7, partyName: "SP", vote: 2431 },
      { partyId: 8, partyName: "İYİP", vote: 17884 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1877,
    union2Vote: 300,
    parliamentarianCount: 3,
  },
  {
    id: 36,
    name: "KARS",
    voterCountTotal: 182194,
    votesCountTotal: 147467,
    votesCountValid: 143051,
    votesCountInvalid: 4416,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 52791 },
      { partyId: 2, partyName: "MHP", vote: 10145 },
      { partyId: 3, partyName: "HUDAPAR", vote: 424 },
      { partyId: 4, partyName: "VATAN", vote: 414 },
      { partyId: 5, partyName: "HDP", vote: 46285 },
      { partyId: 6, partyName: "CHP", vote: 20207 },
      { partyId: 7, partyName: "SP", vote: 973 },
      { partyId: 8, partyName: "İYİP", vote: 10597 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 993,
    union2Vote: 222,
    parliamentarianCount: 3,
  },
  {
    id: 37,
    name: "KASTAMONU",
    voterCountTotal: 285917,
    votesCountTotal: 249191,
    votesCountValid: 241904,
    votesCountInvalid: 7287,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 123900 },
      { partyId: 2, partyName: "MHP", vote: 48471 },
      { partyId: 3, partyName: "HUDAPAR", vote: 727 },
      { partyId: 4, partyName: "VATAN", vote: 1075 },
      { partyId: 5, partyName: "HDP", vote: 1524 },
      { partyId: 6, partyName: "CHP", vote: 37150 },
      { partyId: 7, partyName: "SP", vote: 2281 },
      { partyId: 8, partyName: "İYİP", vote: 22754 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 3496,
    union2Vote: 526,
    parliamentarianCount: 3,
  },
  {
    id: 38,
    name: "KAYSERİ",
    voterCountTotal: 954408,
    votesCountTotal: 864726,
    votesCountValid: 848702,
    votesCountInvalid: 16024,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 420880 },
      { partyId: 2, partyName: "MHP", vote: 182076 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1479 },
      { partyId: 4, partyName: "VATAN", vote: 1274 },
      { partyId: 5, partyName: "HDP", vote: 16193 },
      { partyId: 6, partyName: "CHP", vote: 102885 },
      { partyId: 7, partyName: "SP", vote: 14733 },
      { partyId: 8, partyName: "İYİP", vote: 94607 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 795 },
    ],
    // bagimsiz_toplam_oy: 795,
    union1Vote: 12296,
    union2Vote: 1484,
    parliamentarianCount: 10,
  },
  {
    id: 71,
    name: "KIRIKKALE",
    voterCountTotal: 199395,
    votesCountTotal: 173824,
    votesCountValid: 170629,
    votesCountInvalid: 3195,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 72611 },
      { partyId: 2, partyName: "MHP", vote: 41333 },
      { partyId: 3, partyName: "HUDAPAR", vote: 292 },
      { partyId: 4, partyName: "VATAN", vote: 300 },
      { partyId: 5, partyName: "HDP", vote: 1881 },
      { partyId: 6, partyName: "CHP", vote: 25752 },
      { partyId: 7, partyName: "SP", vote: 2062 },
      { partyId: 8, partyName: "İYİP", vote: 23624 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2378,
    union2Vote: 396,
    parliamentarianCount: 3,
  },
  {
    id: 39,
    name: "KIRKLARELİ",
    voterCountTotal: 273082,
    votesCountTotal: 246416,
    votesCountValid: 241347,
    votesCountInvalid: 5069,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 62148 },
      { partyId: 2, partyName: "MHP", vote: 11367 },
      { partyId: 3, partyName: "HUDAPAR", vote: 358 },
      { partyId: 4, partyName: "VATAN", vote: 675 },
      { partyId: 5, partyName: "HDP", vote: 7123 },
      { partyId: 6, partyName: "CHP", vote: 116179 },
      { partyId: 7, partyName: "SP", vote: 1434 },
      { partyId: 8, partyName: "İYİP", vote: 40069 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 61 },
    ],
    // bagimsiz_toplam_oy: 61,
    union1Vote: 1030,
    union2Vote: 903,
    parliamentarianCount: 3,
  },
  {
    id: 40,
    name: "KIRŞEHİR",
    voterCountTotal: 166167,
    votesCountTotal: 143297,
    votesCountValid: 139891,
    votesCountInvalid: 3406,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 56059 },
      { partyId: 2, partyName: "MHP", vote: 23573 },
      { partyId: 3, partyName: "HUDAPAR", vote: 254 },
      { partyId: 4, partyName: "VATAN", vote: 283 },
      { partyId: 5, partyName: "HDP", vote: 6029 },
      { partyId: 6, partyName: "CHP", vote: 35870 },
      { partyId: 7, partyName: "SP", vote: 1396 },
      { partyId: 8, partyName: "İYİP", vote: 14338 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 101 },
    ],
    // bagimsiz_toplam_oy: 101,
    union1Vote: 1669,
    union2Vote: 319,
    parliamentarianCount: 2,
  },
  {
    id: 79,
    name: "KİLİS",
    voterCountTotal: 86080,
    votesCountTotal: 75129,
    votesCountValid: 73424,
    votesCountInvalid: 1705,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 36706 },
      { partyId: 2, partyName: "MHP", vote: 14977 },
      { partyId: 3, partyName: "HUDAPAR", vote: 177 },
      { partyId: 4, partyName: "VATAN", vote: 125 },
      { partyId: 5, partyName: "HDP", vote: 1347 },
      { partyId: 6, partyName: "CHP", vote: 10575 },
      { partyId: 7, partyName: "SP", vote: 996 },
      { partyId: 8, partyName: "İYİP", vote: 7546 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 845,
    union2Vote: 130,
    parliamentarianCount: 2,
  },
  {
    id: 41,
    name: "KOCAELİ",
    voterCountTotal: 1336401,
    votesCountTotal: 1198849,
    votesCountValid: 1175662,
    votesCountInvalid: 23187,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 556671 },
      { partyId: 2, partyName: "MHP", vote: 132452 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1843 },
      { partyId: 4, partyName: "VATAN", vote: 2014 },
      { partyId: 5, partyName: "HDP", vote: 82860 },
      { partyId: 6, partyName: "CHP", vote: 235465 },
      { partyId: 7, partyName: "SP", vote: 25950 },
      { partyId: 8, partyName: "İYİP", vote: 122645 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 124 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 376 },
    ],
    // bagimsiz_toplam_oy: 500,
    union1Vote: 12151,
    union2Vote: 3111,
    parliamentarianCount: 14,
  },
  {
    id: 42,
    name: "KONYA",
    voterCountTotal: 1505540,
    votesCountTotal: 1341859,
    votesCountValid: 1312952,
    votesCountInvalid: 28907,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 771547 },
      { partyId: 2, partyName: "MHP", vote: 203301 },
      { partyId: 3, partyName: "HUDAPAR", vote: 2787 },
      { partyId: 4, partyName: "VATAN", vote: 1996 },
      { partyId: 5, partyName: "HDP", vote: 43228 },
      { partyId: 6, partyName: "CHP", vote: 122916 },
      { partyId: 7, partyName: "SP", vote: 31092 },
      { partyId: 8, partyName: "İYİP", vote: 118899 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 420 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 176 },
    ],
    // bagimsiz_toplam_oy: 596,
    union1Vote: 14734,
    union2Vote: 1856,
    parliamentarianCount: 15,
  },
  {
    id: 43,
    name: "KÜTAHYA",
    voterCountTotal: 422653,
    votesCountTotal: 386024,
    votesCountValid: 377486,
    votesCountInvalid: 8538,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 203939 },
      { partyId: 2, partyName: "MHP", vote: 69737 },
      { partyId: 3, partyName: "HUDAPAR", vote: 811 },
      { partyId: 4, partyName: "VATAN", vote: 900 },
      { partyId: 5, partyName: "HDP", vote: 2678 },
      { partyId: 6, partyName: "CHP", vote: 46808 },
      { partyId: 7, partyName: "SP", vote: 6841 },
      { partyId: 8, partyName: "İYİP", vote: 40501 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 4542,
    union2Vote: 729,
    parliamentarianCount: 5,
  },
  {
    id: 44,
    name: "MALATYA",
    voterCountTotal: 555931,
    votesCountTotal: 487151,
    votesCountValid: 478686,
    votesCountInvalid: 8465,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 254970 },
      { partyId: 2, partyName: "MHP", vote: 77413 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1619 },
      { partyId: 4, partyName: "VATAN", vote: 655 },
      { partyId: 5, partyName: "HDP", vote: 32081 },
      { partyId: 6, partyName: "CHP", vote: 79605 },
      { partyId: 7, partyName: "SP", vote: 7247 },
      { partyId: 8, partyName: "İYİP", vote: 20347 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 4184,
    union2Vote: 565,
    parliamentarianCount: 6,
  },
  {
    id: 45,
    name: "MANİSA",
    voterCountTotal: 1046410,
    votesCountTotal: 953742,
    votesCountValid: 930198,
    votesCountInvalid: 23544,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 363916 },
      { partyId: 2, partyName: "MHP", vote: 105643 },
      { partyId: 3, partyName: "HUDAPAR", vote: 2545 },
      { partyId: 4, partyName: "VATAN", vote: 2739 },
      { partyId: 5, partyName: "HDP", vote: 62198 },
      { partyId: 6, partyName: "CHP", vote: 245894 },
      { partyId: 7, partyName: "SP", vote: 8666 },
      { partyId: 8, partyName: "İYİP", vote: 128002 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 8124,
    union2Vote: 2471,
    parliamentarianCount: 10,
  },
  {
    id: 47,
    name: "MARDİN",
    voterCountTotal: 471225,
    votesCountTotal: 395732,
    votesCountValid: 385281,
    votesCountInvalid: 10451,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 113634 },
      { partyId: 2, partyName: "MHP", vote: 9387 },
      { partyId: 3, partyName: "HUDAPAR", vote: 8253 },
      { partyId: 4, partyName: "VATAN", vote: 641 },
      { partyId: 5, partyName: "HDP", vote: 233657 },
      { partyId: 6, partyName: "CHP", vote: 10915 },
      { partyId: 7, partyName: "SP", vote: 3151 },
      { partyId: 8, partyName: "İYİP", vote: 3952 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 96 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 254 },
    ],
    // bagimsiz_toplam_oy: 350,
    union1Vote: 1136,
    union2Vote: 205,
    parliamentarianCount: 6,
  },
  {
    id: 33,
    name: "MERSİN",
    voterCountTotal: 1272836,
    votesCountTotal: 1123450,
    votesCountValid: 1102558,
    votesCountInvalid: 20892,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 302200 },
      { partyId: 2, partyName: "MHP", vote: 139581 },
      { partyId: 3, partyName: "HUDAPAR", vote: 4486 },
      { partyId: 4, partyName: "VATAN", vote: 2391 },
      { partyId: 5, partyName: "HDP", vote: 186663 },
      { partyId: 6, partyName: "CHP", vote: 296514 },
      { partyId: 7, partyName: "SP", vote: 7515 },
      { partyId: 8, partyName: "İYİP", vote: 151924 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 374 },
    ],
    // bagimsiz_toplam_oy: 374,
    union1Vote: 8372,
    union2Vote: 2538,
    parliamentarianCount: 13,
  },
  {
    id: 48,
    name: "MUĞLA",
    voterCountTotal: 725909,
    votesCountTotal: 642952,
    votesCountValid: 628627,
    votesCountInvalid: 14325,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 169767 },
      { partyId: 2, partyName: "MHP", vote: 39793 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1378 },
      { partyId: 4, partyName: "VATAN", vote: 2615 },
      { partyId: 5, partyName: "HDP", vote: 40278 },
      { partyId: 6, partyName: "CHP", vote: 259707 },
      { partyId: 7, partyName: "SP", vote: 3785 },
      { partyId: 8, partyName: "İYİP", vote: 105395 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 3524,
    union2Vote: 2385,
    parliamentarianCount: 7,
  },
  {
    id: 49,
    name: "MUŞ",
    voterCountTotal: 228826,
    votesCountTotal: 189275,
    votesCountValid: 183037,
    votesCountInvalid: 6238,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 57747 },
      { partyId: 2, partyName: "MHP", vote: 6527 },
      { partyId: 3, partyName: "HUDAPAR", vote: 2784 },
      { partyId: 4, partyName: "VATAN", vote: 391 },
      { partyId: 5, partyName: "HDP", vote: 101744 },
      { partyId: 6, partyName: "CHP", vote: 3633 },
      { partyId: 7, partyName: "SP", vote: 1652 },
      { partyId: 8, partyName: "İYİP", vote: 7881 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 584,
    union2Vote: 94,
    parliamentarianCount: 3,
  },
  {
    id: 50,
    name: "NEVŞEHİR",
    voterCountTotal: 210901,
    votesCountTotal: 189162,
    votesCountValid: 185381,
    votesCountInvalid: 3781,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 96984 },
      { partyId: 2, partyName: "MHP", vote: 33106 },
      { partyId: 3, partyName: "HUDAPAR", vote: 551 },
      { partyId: 4, partyName: "VATAN", vote: 418 },
      { partyId: 5, partyName: "HDP", vote: 2335 },
      { partyId: 6, partyName: "CHP", vote: 30496 },
      { partyId: 7, partyName: "SP", vote: 2175 },
      { partyId: 8, partyName: "İYİP", vote: 16841 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2151,
    union2Vote: 324,
    parliamentarianCount: 3,
  },
  {
    id: 51,
    name: "NİĞDE",
    voterCountTotal: 240315,
    votesCountTotal: 210930,
    votesCountValid: 206290,
    votesCountInvalid: 4640,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 88103 },
      { partyId: 2, partyName: "MHP", vote: 42719 },
      { partyId: 3, partyName: "HUDAPAR", vote: 443 },
      { partyId: 4, partyName: "VATAN", vote: 613 },
      { partyId: 5, partyName: "HDP", vote: 2424 },
      { partyId: 6, partyName: "CHP", vote: 41597 },
      { partyId: 7, partyName: "SP", vote: 2487 },
      { partyId: 8, partyName: "İYİP", vote: 24788 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2716,
    union2Vote: 400,
    parliamentarianCount: 3,
  },
  {
    id: 52,
    name: "ORDU",
    voterCountTotal: 558478,
    votesCountTotal: 484245,
    votesCountValid: 470149,
    votesCountInvalid: 14096,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 223444 },
      { partyId: 2, partyName: "MHP", vote: 78591 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1244 },
      { partyId: 4, partyName: "VATAN", vote: 1745 },
      { partyId: 5, partyName: "HDP", vote: 4269 },
      { partyId: 6, partyName: "CHP", vote: 106924 },
      { partyId: 7, partyName: "SP", vote: 5382 },
      { partyId: 8, partyName: "İYİP", vote: 40161 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 7340,
    union2Vote: 1049,
    parliamentarianCount: 6,
  },
  {
    id: 80,
    name: "OSMANİYE",
    voterCountTotal: 358510,
    votesCountTotal: 308729,
    votesCountValid: 303085,
    votesCountInvalid: 5644,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 105800 },
      { partyId: 2, partyName: "MHP", vote: 95799 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1157 },
      { partyId: 4, partyName: "VATAN", vote: 652 },
      { partyId: 5, partyName: "HDP", vote: 9585 },
      { partyId: 6, partyName: "CHP", vote: 40424 },
      { partyId: 7, partyName: "SP", vote: 2987 },
      { partyId: 8, partyName: "İYİP", vote: 41087 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 5113,
    union2Vote: 481,
    parliamentarianCount: 4,
  },
  {
    id: 53,
    name: "RİZE",
    voterCountTotal: 252766,
    votesCountTotal: 222114,
    votesCountValid: 217507,
    votesCountInvalid: 4607,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 139948 },
      { partyId: 2, partyName: "MHP", vote: 26907 },
      { partyId: 3, partyName: "HUDAPAR", vote: 228 },
      { partyId: 4, partyName: "VATAN", vote: 354 },
      { partyId: 5, partyName: "HDP", vote: 2048 },
      { partyId: 6, partyName: "CHP", vote: 27800 },
      { partyId: 7, partyName: "SP", vote: 4096 },
      { partyId: 8, partyName: "İYİP", vote: 13088 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 252 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 24 },
    ],
    // bagimsiz_toplam_oy: 276,
    union1Vote: 2365,
    union2Vote: 397,
    parliamentarianCount: 3,
  },
  {
    id: 54,
    name: "SAKARYA",
    voterCountTotal: 705678,
    votesCountTotal: 637350,
    votesCountValid: 625866,
    votesCountInvalid: 11484,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 358992 },
      { partyId: 2, partyName: "MHP", vote: 84952 },
      { partyId: 3, partyName: "HUDAPAR", vote: 856 },
      { partyId: 4, partyName: "VATAN", vote: 1180 },
      { partyId: 5, partyName: "HDP", vote: 14048 },
      { partyId: 6, partyName: "CHP", vote: 84316 },
      { partyId: 7, partyName: "SP", vote: 12982 },
      { partyId: 8, partyName: "İYİP", vote: 59290 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 7898,
    union2Vote: 1352,
    parliamentarianCount: 8,
  },
  {
    id: 55,
    name: "SAMSUN",
    voterCountTotal: 960245,
    votesCountTotal: 848938,
    votesCountValid: 827725,
    votesCountInvalid: 21213,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 421974 },
      { partyId: 2, partyName: "MHP", vote: 133763 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1281 },
      { partyId: 4, partyName: "VATAN", vote: 1748 },
      { partyId: 5, partyName: "HDP", vote: 10645 },
      { partyId: 6, partyName: "CHP", vote: 141808 },
      { partyId: 7, partyName: "SP", vote: 11854 },
      { partyId: 8, partyName: "İYİP", vote: 91077 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 130 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 585 },
    ],
    // bagimsiz_toplam_oy: 715,
    union1Vote: 10969,
    union2Vote: 1891,
    parliamentarianCount: 9,
  },
  {
    id: 56,
    name: "SİİRT",
    voterCountTotal: 180215,
    votesCountTotal: 151462,
    votesCountValid: 146267,
    votesCountInvalid: 5195,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 55890 },
      { partyId: 2, partyName: "MHP", vote: 4905 },
      { partyId: 3, partyName: "HUDAPAR", vote: 1776 },
      { partyId: 4, partyName: "VATAN", vote: 269 },
      { partyId: 5, partyName: "HDP", vote: 76225 },
      { partyId: 6, partyName: "CHP", vote: 2990 },
      { partyId: 7, partyName: "SP", vote: 1355 },
      { partyId: 8, partyName: "İYİP", vote: 2181 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 573,
    union2Vote: 103,
    parliamentarianCount: 3,
  },
  {
    id: 57,
    name: "SİNOP",
    voterCountTotal: 160081,
    votesCountTotal: 140110,
    votesCountValid: 135289,
    votesCountInvalid: 4821,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 73639 },
      { partyId: 2, partyName: "MHP", vote: 9562 },
      { partyId: 3, partyName: "HUDAPAR", vote: 444 },
      { partyId: 4, partyName: "VATAN", vote: 778 },
      { partyId: 5, partyName: "HDP", vote: 2065 },
      { partyId: 6, partyName: "CHP", vote: 32784 },
      { partyId: 7, partyName: "SP", vote: 1516 },
      { partyId: 8, partyName: "İYİP", vote: 12675 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1445,
    union2Vote: 381,
    parliamentarianCount: 2,
  },
  {
    id: 58,
    name: "SİVAS",
    voterCountTotal: 450597,
    votesCountTotal: 404295,
    votesCountValid: 397033,
    votesCountInvalid: 7262,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 213446 },
      { partyId: 2, partyName: "MHP", vote: 75405 },
      { partyId: 3, partyName: "HUDAPAR", vote: 532 },
      { partyId: 4, partyName: "VATAN", vote: 615 },
      { partyId: 5, partyName: "HDP", vote: 6863 },
      { partyId: 6, partyName: "CHP", vote: 59813 },
      { partyId: 7, partyName: "SP", vote: 7052 },
      { partyId: 8, partyName: "İYİP", vote: 27292 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 266 },
    ],
    // bagimsiz_toplam_oy: 266,
    union1Vote: 5151,
    union2Vote: 598,
    parliamentarianCount: 5,
  },
  {
    id: 63,
    name: "ŞANLIURFA",
    voterCountTotal: 1063482,
    votesCountTotal: 864333,
    votesCountValid: 843861,
    votesCountInvalid: 20472,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 440085 },
      { partyId: 2, partyName: "MHP", vote: 77479 },
      { partyId: 3, partyName: "HUDAPAR", vote: 13495 },
      { partyId: 4, partyName: "VATAN", vote: 927 },
      { partyId: 5, partyName: "HDP", vote: 247256 },
      { partyId: 6, partyName: "CHP", vote: 28880 },
      { partyId: 7, partyName: "SP", vote: 10913 },
      { partyId: 8, partyName: "İYİP", vote: 14965 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 3062 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 386 },
    ],
    // bagimsiz_toplam_oy: 3448,
    union1Vote: 5882,
    union2Vote: 531,
    parliamentarianCount: 14,
  },
  {
    id: 73,
    name: "ŞIRNAK",
    voterCountTotal: 268840,
    votesCountTotal: 233565,
    votesCountValid: 226738,
    votesCountInvalid: 6827,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 38523 },
      { partyId: 2, partyName: "MHP", vote: 8721 },
      { partyId: 3, partyName: "HUDAPAR", vote: 4847 },
      { partyId: 4, partyName: "VATAN", vote: 344 },
      { partyId: 5, partyName: "HDP", vote: 162969 },
      { partyId: 6, partyName: "CHP", vote: 5048 },
      { partyId: 7, partyName: "SP", vote: 1001 },
      { partyId: 8, partyName: "İYİP", vote: 4284 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 408 },
    ],
    // bagimsiz_toplam_oy: 408,
    union1Vote: 448,
    union2Vote: 145,
    parliamentarianCount: 4,
  },
  {
    id: 59,
    name: "TEKİRDAĞ",
    voterCountTotal: 737697,
    votesCountTotal: 657317,
    votesCountValid: 644493,
    votesCountInvalid: 12824,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 216811 },
      { partyId: 2, partyName: "MHP", vote: 47860 },
      { partyId: 3, partyName: "HUDAPAR", vote: 904 },
      { partyId: 4, partyName: "VATAN", vote: 1589 },
      { partyId: 5, partyName: "HDP", vote: 40274 },
      { partyId: 6, partyName: "CHP", vote: 248539 },
      { partyId: 7, partyName: "SP", vote: 5018 },
      { partyId: 8, partyName: "İYİP", vote: 76707 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 229 },
    ],
    // bagimsiz_toplam_oy: 229,
    union1Vote: 4394,
    union2Vote: 2168,
    parliamentarianCount: 8,
  },
  {
    id: 60,
    name: "TOKAT",
    voterCountTotal: 424187,
    votesCountTotal: 382498,
    votesCountValid: 374996,
    votesCountInvalid: 7502,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 183402 },
      { partyId: 2, partyName: "MHP", vote: 61264 },
      { partyId: 3, partyName: "HUDAPAR", vote: 615 },
      { partyId: 4, partyName: "VATAN", vote: 664 },
      { partyId: 5, partyName: "HDP", vote: 5999 },
      { partyId: 6, partyName: "CHP", vote: 77417 },
      { partyId: 7, partyName: "SP", vote: 4834 },
      { partyId: 8, partyName: "İYİP", vote: 35463 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 4733,
    union2Vote: 605,
    parliamentarianCount: 5,
  },
  {
    id: 61,
    name: "TRABZON",
    voterCountTotal: 583892,
    votesCountTotal: 509406,
    votesCountValid: 497820,
    votesCountInvalid: 11586,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 274490 },
      { partyId: 2, partyName: "MHP", vote: 66992 },
      { partyId: 3, partyName: "HUDAPAR", vote: 615 },
      { partyId: 4, partyName: "VATAN", vote: 916 },
      { partyId: 5, partyName: "HDP", vote: 4273 },
      { partyId: 6, partyName: "CHP", vote: 74348 },
      { partyId: 7, partyName: "SP", vote: 12495 },
      { partyId: 8, partyName: "İYİP", vote: 56267 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 207 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 80 },
    ],
    // bagimsiz_toplam_oy: 287,
    union1Vote: 6035,
    union2Vote: 1102,
    parliamentarianCount: 6,
  },
  {
    id: 62,
    name: "TUNCELİ",
    voterCountTotal: 64299,
    votesCountTotal: 55449,
    votesCountValid: 54194,
    votesCountInvalid: 1255,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 7228 },
      { partyId: 2, partyName: "MHP", vote: 3019 },
      { partyId: 3, partyName: "HUDAPAR", vote: 57 },
      { partyId: 4, partyName: "VATAN", vote: 63 },
      { partyId: 5, partyName: "HDP", vote: 28219 },
      { partyId: 6, partyName: "CHP", vote: 14358 },
      { partyId: 7, partyName: "SP", vote: 165 },
      { partyId: 8, partyName: "İYİP", vote: 849 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 15 },
    ],
    // bagimsiz_toplam_oy: 15,
    union1Vote: 170,
    union2Vote: 51,
    parliamentarianCount: 1,
  },
  {
    id: 64,
    name: "UŞAK",
    voterCountTotal: 266929,
    votesCountTotal: 242827,
    votesCountValid: 236007,
    votesCountInvalid: 6820,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 100364 },
      { partyId: 2, partyName: "MHP", vote: 24672 },
      { partyId: 3, partyName: "HUDAPAR", vote: 604 },
      { partyId: 4, partyName: "VATAN", vote: 724 },
      { partyId: 5, partyName: "HDP", vote: 6195 },
      { partyId: 6, partyName: "CHP", vote: 67031 },
      { partyId: 7, partyName: "SP", vote: 3263 },
      { partyId: 8, partyName: "İYİP", vote: 30507 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 2049,
    union2Vote: 598,
    parliamentarianCount: 3,
  },
  {
    id: 65,
    name: "VAN",
    voterCountTotal: 639730,
    votesCountTotal: 529789,
    votesCountValid: 511859,
    votesCountInvalid: 17930,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 157637 },
      { partyId: 2, partyName: "MHP", vote: 14798 },
      { partyId: 3, partyName: "HUDAPAR", vote: 4753 },
      { partyId: 4, partyName: "VATAN", vote: 808 },
      { partyId: 5, partyName: "HDP", vote: 310273 },
      { partyId: 6, partyName: "CHP", vote: 10946 },
      { partyId: 7, partyName: "SP", vote: 4031 },
      { partyId: 8, partyName: "İYİP", vote: 5992 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 127 },
      { partyId: -2, partyName: "Bağımsız 2", vote: 187 },
    ],
    // bagimsiz_toplam_oy: 314,
    union1Vote: 2009,
    union2Vote: 298,
    parliamentarianCount: 8,
  },
  {
    id: 77,
    name: "YALOVA",
    voterCountTotal: 178253,
    votesCountTotal: 155158,
    votesCountValid: 152467,
    votesCountInvalid: 2691,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 65787 },
      { partyId: 2, partyName: "MHP", vote: 11659 },
      { partyId: 3, partyName: "HUDAPAR", vote: 286 },
      { partyId: 4, partyName: "VATAN", vote: 322 },
      { partyId: 5, partyName: "HDP", vote: 11713 },
      { partyId: 6, partyName: "CHP", vote: 43843 },
      { partyId: 7, partyName: "SP", vote: 1995 },
      { partyId: 8, partyName: "İYİP", vote: 15089 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 1347,
    union2Vote: 426,
    parliamentarianCount: 3,
  },
  {
    id: 66,
    name: "YOZGAT",
    voterCountTotal: 296869,
    votesCountTotal: 256041,
    votesCountValid: 251204,
    votesCountInvalid: 4837,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 131340 },
      { partyId: 2, partyName: "MHP", vote: 62006 },
      { partyId: 3, partyName: "HUDAPAR", vote: 443 },
      { partyId: 4, partyName: "VATAN", vote: 430 },
      { partyId: 5, partyName: "HDP", vote: 2100 },
      { partyId: 6, partyName: "CHP", vote: 28575 },
      { partyId: 7, partyName: "SP", vote: 2966 },
      { partyId: 8, partyName: "İYİP", vote: 18727 },
    ],
    // bagimsiz_toplam_oy: 0,
    union1Vote: 4294,
    union2Vote: 323,
    parliamentarianCount: 4,
  },
  {
    id: 67,
    name: "ZONGULDAK",
    voterCountTotal: 447085,
    votesCountTotal: 392815,
    votesCountValid: 377652,
    votesCountInvalid: 15163,
    votes: [
      { partyId: 1, partyName: "AKP", vote: 170175 },
      { partyId: 2, partyName: "MHP", vote: 40689 },
      { partyId: 3, partyName: "HUDAPAR", vote: 815 },
      { partyId: 4, partyName: "VATAN", vote: 1522 },
      { partyId: 5, partyName: "HDP", vote: 5382 },
      { partyId: 6, partyName: "CHP", vote: 116804 },
      { partyId: 7, partyName: "SP", vote: 6726 },
      { partyId: 8, partyName: "İYİP", vote: 29677 },
      { partyId: -1, partyName: "Bağımsız 1", vote: 1191 },
    ],
    // bagimsiz_toplam_oy: 1191,
    union1Vote: 3461,
    union2Vote: 1210,
    parliamentarianCount: 5,
  },
];
